import React, { useState } from "react";
import { Button, Grid, TextField, Box, InputLabel } from "@mui/material";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../../API/AuthLayer";
import { notify } from "../Common";
import { ReactComponent as Spinner_2 } from "../../Assets/Spinner_2.svg";
import "./Login.css";

export default function PasswordResetRequest() {
  const methods = useForm();
  const { handleSubmit, control, formState: { errors } } = methods;
  const [apiLoading, setApiLoading] = useState(false);

  const onSubmit = (data) => {
    setApiLoading(true);
    requestPasswordReset(data.email)
      .then((res) => {
        notify("success", "If an account matches, a recovery link has been sent.");
        setApiLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        notify("error", "Failed to register request. Verify parameters.");
        setApiLoading(false);
      });
  };

  return (
    <div style={{ padding: "auto", margin: "60px 10px 0 10px" }}>
      <Box container sx={{ maxWidth: "412px", margin: "20px auto" , padding: "20px auto" }}>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <p className="heading" style={{ marginBottom: "8px" }}>Reset Password</p>
            <p style={{ marginBottom: "38px" }}>
              Enter your account's email address and we'll send a link to reset your password.
            </p>
            
            <Grid item xs={12}>
              <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>Enter your Email *</InputLabel>
              <Controller
                name="email"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    type="email"
                    {...field}
                    size="small"
                    fullWidth
                    sx={{ marginBottom: "10px" }}
                    error={Boolean(errors.email)}
                    helperText={errors.email && "Email is required"}
                  />
                )}
              />
            </Grid>

            <Button
              variant="contained"
              fullWidth
              type="submit"
              sx={{
                textTransform: "capitalize",
                padding: "16px 0 15px 0",
                marginTop: "25px",
                background: "linear-gradient(272.65deg, #383194 0%, #da1e7a 100%)",
                borderRadius: "5px",
                fontWeight: 700,
                fontSize: "16px",
              }}
            >
              Send Reset Link
            </Button>

            <Link to="/login" className="no-underline">
              <p className="Link" style={{ marginTop: "20px", textAlign: "center" }}>
                « Back to Login
              </p>
            </Link>
          </form>
        </FormProvider>
      </Box>

      {apiLoading && (
        <div className="overlay">
          <Spinner_2 style={{ width: "80px" }} />
        </div>
      )}
    </div>
  );
}